// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2k-0";
export var spinnerContainer = "_2k-1";